module.exports = __webpack_public_path__ + "assets/CleaverDetailed.ae2e8bb0d0b356be039ead193d69a4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CleaverDetailed.png
// module id = 498
// module chunks = 0